import { requestQueue } from '../lib/requestQueue';

class SearchService {
  async performLocalSearch(query) {
    try {
      const response = await fetch('/api/search-local', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query }),
      });
      if (!response.ok) throw new Error(`Local search failed: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('Local search error:', error);
      return { error: error.message };
    }
  }

  async performAISearch(query, articles = []) {
    return requestQueue.add(async () => {
      try {
        // Format context from articles if available
        const context = articles.length > 0
          ? articles.map(a => `Title: ${a.title}\nContent: ${a.content}\nURL: ${a.link}\n---`).join('\n\n')
          : '';

        const response = await fetch('/api/ai-search', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query, context }),
        });

        if (response.status === 429) return { error: "Rate limit exceeded" };
        if (!response.ok) throw new Error(`AI search failed: ${response.status}`);

        return await response.json();
      } catch (error) {
        console.error('AI search error:', error);
        return { error: error.message };
      }
    });
  }

  async performUnifiedSearch(query) {
    try {
      const response = await fetch('/api/unified-search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query }),
      });

      if (response.status === 429) return { error: "Rate limit exceeded" };
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || `Unified search failed: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Unified search error:', error);
      return { error: error.message };
    }
  }

  cleanAIResponse(text) {
    if (!text) return '';

    return text
      .replace(/\*\*(.*?)\*\*/g, '$1')
      .replace(/\*(.*?)\*/g, '$1')
      .replace(/^#{1,6}\s+/gm, '')
      .replace(/^[\s]*[-*+]\s+/gm, '')
      .replace(/``````/g, '')
      .replace(/`([^`]+)`/g, '$1')
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      .replace(/\s+/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
}

export const searchService = new SearchService();
